/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

var data = [];
var push = function push(value) {
  data.push(value);
};
var pop = function pop(value) {
  if (data.length && data.includes(value)) {
    data.pop();
  }
};
var stack = {
  push: push,
  pop: pop,
  get top() {
    return data[data.length - 1];
  }
};

export { stack as default };
//# sourceMappingURL=stack.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/dialog/stack.js
// module id = null
// module chunks = 